export class BrowserUtility {
  static save(key: string, value: string): void {
    window.localStorage.setItem(key, value);
  }

  static get(key: string): string | null {
    return window.localStorage.getItem(key);
  }

  static saveObj<T extends object>(key: string, obj: T): void {
    window.localStorage.setItem(key, JSON.stringify(obj));
  }

  static getObj<T = any>(key: string): T | null {
    const temp = window.localStorage.getItem(key);
    if (temp) {
      try {
        return JSON.parse(temp) as T;
      } catch {
        return null;
      }
    }
    return null;
  }

  static remove(key: string): void {
    window.localStorage.removeItem(key);
  }

  static removeAll(): void {
    window.localStorage.clear();
  }

  /** Clear localStorage while keeping specific keys (e.g. user preferences). */
  static clearExcept(preserveKeys: string[]): void {
    const preserved = preserveKeys.reduce<Record<string, string>>((acc, key) => {
      const value = window.localStorage.getItem(key);
      if (value !== null) {
        acc[key] = value;
      }
      return acc;
    }, {});

    window.localStorage.clear();

    preserveKeys.forEach(key => {
      if (preserved[key] !== undefined) {
        window.localStorage.setItem(key, preserved[key]);
      }
    });
  }

  static isMobileSafari(): boolean {
    const ua = window.navigator.userAgent;
    return /(iPad|iPhone|iPod).*WebKit/.test(ua) && !/(CriOS|OPiOS)/.test(ua);
  }
}
